
import mixins from '@mods/store/template'
import {
    HttpProductList,
    HttpAllProductList,
    HttpWarehouseList,
    HttpAccountList,
    HttpProductLineAllList,
    HttpAccountAllList,
    HttpUserList,
    HttpAllaccountType,
} from "@/service/boss/dictionary";

import {
    HttpGetAllSalesmanList,
    HttpGetAllCustomerList
} from "@/service/manage/manage";

import {
	HttpGetCurrency
} from '@/service/products/allproducts'
import {
	HttpGetCostGroupNameList
} from '@/service/boss/cost'
import {
	HttpGetAllSupplier
} from '@/service/purchase/purchase'
const list = [
    {
        name: 'newProductList',//项目
        ajaxRequest: HttpProductList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.name}`,
            attach: {
                supplierId:item.supplierId,
                paymentType:item.paymentType,
                nickname:item.nickname
            }
        })),
    },
    {
        name: 'newDifferentAllProductList',//项目(区分组织，包含已关闭，已停用)
        ajaxRequest: HttpAllProductList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.name}`,
            attach: {
                flag:item.flag
            }
        })),
    },
    {
        name: 'newAllProductList',//全部项目（不分组织）
        ajaxRequest: HttpProductLineAllList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.name}`,
            attach: {
                name:`${item.name}`
            }
        })),
    },
    {
        name: 'newAccountList',//渠道flag
        ajaxRequest: HttpAccountList,
        interceptResponse: data => data.map(item => ({
            value: item.flag,
            label: `${item.title}(${item.flag})`,
            attach: {
                id:item.id,
                siteName:item.siteName,
                currency:item.currency,
                type:item.type,
                status:item.status,
            }
        })),
    },
    {
        name: 'newAccountIdList',//渠道title
        ajaxRequest: HttpAccountList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.title}(${item.flag})`,
            attach: {
                item
            }
        })),
    },
    {
        name: 'newAllAccountIdList',//全部渠道（不分组织）
        ajaxRequest: HttpAccountAllList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.title}(${item.flag})`,
            attach: {
                ...item
            }
        })),
    },
    {
        name: 'newAccountType',//渠道类型
        ajaxRequest: HttpAllaccountType,
        interceptResponse: data => data.map(item => ({
            value: item.name,
            label: item.name,
            attach:{
                id:item.id
            }
        })),
    },
    {
        name: 'newWarehouseCodeList',//仓库
        ajaxRequest: HttpWarehouseList,
        interceptResponse: data => data.map(item => ({
            value: item.code,
            label: `${item.code}(${item.title})`,
            attach: {
                warehouseType:item.warehouseType,
                id:item.id,
                code:item.code,
            }
        })),
    },
    {
        name: 'newWarehouseIdList',//仓库
        ajaxRequest: HttpWarehouseList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.code}(${item.title})`,
            attach: {
                item
            }
        })),
    },
    
    // 销售员列表
    {
        name: 'allSalesList',
        ajaxRequest: HttpGetAllSalesmanList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.fullName}`,
            // attach: {
            //     item
            // }
        })),
    },
    // 客户列表
    {
        name: 'allCustomerList',
        ajaxRequest: HttpGetAllCustomerList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.customerName}`,
            attach: {
                item
            }
        })),
    },
    // 币种
    {
        name: 'allCurrency',
        ajaxRequest: HttpGetCurrency,
        interceptResponse: data => data.map(item => ({
            value: item.currency,
            label: `${item.currency}(${item.currencyCn})`,
            // attach: {
            //     item
            // }
        })),
    },
    // 获取成本组名称
    {
        name: 'allCostGroupName',
        ajaxRequest: HttpGetCostGroupNameList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.groupName}`,
            // attach: {
            //     item
            // }
        })),
    },
    // 获取供应商全部
    {
        name: 'allSupplier',
        ajaxRequest: HttpGetAllSupplier,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.name}`,
            attach: {
                ...item
            }
        })),
    },
    // 项目负责人
    {
        name: 'allProductPerson',
        ajaxRequest: HttpUserList,
        interceptResponse: data => data.map(item => ({
            value: item.name,
            label: `${item.name}`,
            attach: {
                id:item.id
            }
        })),
    },
]


export default mixins(list)
